import React from "react";
import { Button, Divider, Box, Stack, Typography, Grid } from "@mui/material";
import { Link as DomLink } from "react-router-dom";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import remarkGfm from "remark-gfm";
import {
  stackPageSx,
  boxGridSx,
  stackBtnSx,
} from "../../styles/AuctionHouseSx";
import useMediaQueryUtils from "../../../../../utils/mediaQueryUtils";
import { constants } from "../../../../../utils";

const strapiURL = constants.CMS_FRONT_IMAGE_URL;

function Sell(props) {
  const isMdScreen = useMediaQueryUtils("md");
  const {
    SellImageTextTop,
    SellImageTextMiddle,
    SellImageTextFAQ,
    UpcomingAuctions,
  } = props;
  return (
    <>
      <Grid container spacing={1}>
        {SellImageTextTop && (
          <>
            <Grid item xs={12} md={6}>
              <div>
                <img
                  width={isMdScreen ? "100%" : "90%"}
                  src={`${strapiURL}${SellImageTextTop.image.data.attributes.url}`}
                  alt="banner"
                />
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={1} textAlign={"left"}>
                <Typography variant="h3">{SellImageTextTop.title}</Typography>
                <Typography variant="staticText">
                  <ReactMarkdown remarkGfm={[remarkGfm]}>
                    {SellImageTextTop.body}
                  </ReactMarkdown>
                </Typography>
              </Stack>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Divider flexItem />
          {SellImageTextMiddle && (
            <Stack
              sx={{
                ...stackPageSx,
              }}
            >
              <Box sx={boxGridSx}>
                {isMdScreen ? (
                  <img
                    width={"100%"}
                    src={`${strapiURL}${SellImageTextMiddle.image.data.attributes.url}`}
                    alt="Auction Timeline Banner"
                  />
                ) : null}
                <Stack spacing={1}>
                  <Typography variant="h3">
                    {SellImageTextMiddle.title}
                  </Typography>
                  <Typography variant="staticText">
                    <ReactMarkdown remarkGfm={[remarkGfm]}>
                      {SellImageTextMiddle.body}
                    </ReactMarkdown>
                  </Typography>
                  <Stack sx={stackBtnSx}>
                    <DomLink
                      to={{
                        pathname: "/harmony-auction-signup",
                      }}
                      className="center"
                    >
                      <Button color="success" variant="contained" size="small">
                        Open a Seller Account
                      </Button>
                    </DomLink>
                    <Stack direction="column">
                      <Typography
                        sx={{
                          color: "#7fa04d",
                          margin: "10px",
                          textAlign: "center",
                        }}
                      >
                        Already Participating?
                        {
                          <DomLink
                            to={{
                              pathname: "/myauction-log-in",
                            }}
                            className="center"
                          >
                            <Typography
                              sx={{
                                color: "#7fa04d",
                                textDecoration: "underline",
                              }}
                            >
                              Login
                            </Typography>
                          </DomLink>
                        }
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
                {!isMdScreen ? (
                  <img
                    width={"100%"}
                    src={`${strapiURL}${SellImageTextMiddle.image.data.attributes.url}`}
                    alt="Auction Timeline Banner"
                  />
                ) : null}
              </Box>
            </Stack>
          )}
          <Divider flexItem />
        </Grid>
        <Grid item xs={12}>
          {SellImageTextFAQ && (
            <Stack
              sx={{
                ...stackPageSx,
              }}
            >
              <Box sx={boxGridSx}>
                <div>
                  <img
                    width={"100%"}
                    src={`${strapiURL}${SellImageTextFAQ.image.data.attributes.url}`}
                    alt="banner"
                  />
                  <Stack
                    sx={{
                      padding: "2rem",
                      border: "3px solid #D2B48C",
                    }}
                    spacing={2}
                  >
                    <Typography variant="diamondTabFont" className="center">
                      UPCOMING AUCTIONS
                    </Typography>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          sm: "repeat(1, 1fr)",
                          md: "repeat(2, 1fr)",
                          lg: "repeat(2, 1fr)",
                          xl: "repeat(2, 1fr)",
                        },
                      }}
                    >
                      <Typography variant="staticText">
                        <ReactMarkdown remarkGfm={[remarkGfm]}>
                          {UpcomingAuctions.body}
                        </ReactMarkdown>
                      </Typography>
                    </Box>
                  </Stack>
                </div>
                <Stack spacing={1} marginTop={"3rem"}>
                  <Typography variant="h3">{SellImageTextFAQ.title}</Typography>
                  <Typography variant="staticText">
                    <ReactMarkdown remarkGfm={[remarkGfm]}>
                      {SellImageTextFAQ.body}
                    </ReactMarkdown>
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default Sell;
